var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:_vm.classNames,attrs:{"src":_vm.iconUrl,"alt":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }